import { render, staticRenderFns } from "./UserViewPasswordChange.vue?vue&type=template&id=581d344c&"
import script from "./UserViewPasswordChange.vue?vue&type=script&lang=js&"
export * from "./UserViewPasswordChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports